'use strict';

/**
 * WARNING - USE CAUTION
 *
 * This Service should only be used as a last resort.
 * User Agent detection is considered bad practice due
 * to no standardization and vendors spoofing other browsers.
 * It is vastly preferable to lay down responsive styles.
 *
 * More Info: https://developer.mozilla.org/en-US/docs/Browser_detection_using_the_user_agent
 **/

module.exports = /*@ngInject*/
function(
    $window,
    ReduxService
) {
    return {
        /**
         * Gets the viewport's width
         * @return {Number} Viewport's width
         */
        getWindowWidth() {
            return $window.innerWidth;
        },

        /**
         * The use of isTouchDevice has been deprecated. Modernizr.touch
         * is misleading as it only detects whether the browser supports
         * Touch events, not if the device is a touch device. This method
         * has been changed to make the distinction explicit.
         * @return {Boolean} True, if the browser supports Touch events; false, otherwise.
         */
        hasTouchEvents() {
            return $window.Modernizr.touch;
        },

        /**
         * Is this an Android browser?
         * @return {Boolean} True, if the browser is an Android browser; false, otherwise.
         */
        isAndroid() {
            return /(android)/.test($window.navigator.userAgent.toLowerCase());
        },

        /**
         * Is this a Firefox browser?
         * @return {Boolean} True, if the browser is a Firefox browser; false, otherwise.
         */
        isFirefox() {
            return /firefox/.test($window.navigator.userAgent.toLowerCase());
        },

        /**
         * Is this an IOS browser?
         * @return {Boolean} True, if the browser is an IOS browser; false, otherwise.
         */
        isIOS() {
            return /(ipod|iphone|ipad)/.test($window.navigator.userAgent.toLowerCase());
        },

        /**
         * Is this an IOS Safari browser?
         * @return {Boolean} True, if the browser is an IOS Safari browser; false, otherwise.
         */
        isIOSSafari() {
            return this.isIOS() && this.isSafari();
        },

        /**
         * Is this a large screen viewport, as defined
         * by the small screen width breakpoint in the config.
         * @return {Boolean} True, if this is a large screen viewport; false, otherwise.
         */
        isLargeScreen() {
            return ReduxService.getState()
                .then((state) => {
                    return state.core.deviceCharacteristics.is_large;
                });
        },

        /**
         * Is the site currently in the mobile context i.e. anthro/m
         * @return {Boolean} True, if in the mobile context; false, otherwise.
         */
        isMobileContext: function() {
            return this.isSmallScreen();
        },

        /**
         * Is this a Safari browser?
         * @return {Boolean} True, if the browser is a Safari browser; false, otherwise.
         */
        isSafari() {
            return /AppleWebKit/.test($window.navigator.userAgent);
        },

        /**
         * Is this a small screen viewport, as defined
         * by the small screen width breakpoint in the config.
         * @return {Boolean} True, if this is a small screen viewport; false, otherwise.
         */
        isSmallScreen() {
            return ReduxService.getState()
                .then((state) => {
                    return state.core.deviceCharacteristics.is_mobile;
                });
        },

        /**
         * Is this a Windows Phone browser?
         * @return {Boolean} True, if this is a Windows Phone browser; false, otherwise.
         */
        isWindowsPhone() {
            return /iemobile/.test($window.navigator.userAgent.toLowerCase());
        }
    };
};
